import React, { useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getProjectState } from '../../features/project/selectors';
import { useElementSize } from '../custom-components/useElementSize';

const useStyles = makeStyles(() =>
  createStyles({
    titleStyle: {
      background: 'linear-gradient(225deg, #00308C 0%, #002366 100%)',
      borderRadius: '4px 4px 0px 0px',
    },
  }),
);

export default function DashboardSearch() {
  const classes = useStyles();

  const history = useHistory();
  const project = useSelector(getProjectState);

  const {
    ref,
    size: { width },
  } = useElementSize();

  const isCardSmall = width < 400;

  const [searchInput, setSearchInput] = useState('');

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (project) params.append('projectId', project.id);
    if (searchInput.trim()) params.append('query', searchInput.trim());
    history.push(`/main/search?${params.toString()}`);
  };

  return (
    <Card ref={ref}>
      <CardContent className={classes.titleStyle}>
        <h2
          style={{
            textAlign: 'left',
            color: '#FFFFFF',
            margin: 0,
          }}
        >
          AI Word Finder
        </h2>
      </CardContent>
      <div style={{ display: 'flex', alignItems: 'center', padding: 16 }}>
        <TextField
          size="small"
          placeholder="Find any word in any document..."
          variant="outlined"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSearch();
            }
          }}
          fullWidth
          style={{ marginRight: 16 }}
        />
        {!isCardSmall ? (
          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={handleSearch}
          >
            Search
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
            style={{ paddingLeft: 0, paddingRight: 0 }}
          >
            <SearchIcon />
          </Button>
        )}
      </div>
    </Card>
  );
}
